import Swal from "sweetalert2";
import SupportCodeService from "../../services/SupportCodeService";

let dialogOpen = false;

const showSupportCodeDialog = async (t) => {
    if (dialogOpen) return;
    dialogOpen = true;

    Swal.fire({
        title: t("profile.support-code"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
    });

    let action = "load";
    try {
        let code = await SupportCodeService.getCurrentCode();

        while (code) {
            const result = await Swal.fire({
                title: t("profile.support-code"),
                text: t("profile.support-code-desc"),
                input: "text",
                inputValue: code,
                inputAttributes: {
                    readonly: "readonly",
                    autocomplete: "off",
                    "aria-label": t("profile.support-code"),
                },
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: t("profile.copy-support-code"),
                denyButtonText: t("profile.rotate"),
                cancelButtonText: t("global.close"),
                customClass: {
                    input: "support-code-dialog-input",
                },
            });

            if (result.isConfirmed) {
                action = "copy";
                await SupportCodeService.copyToClipboard(code);
                await Swal.fire({
                    title: t("global.success"),
                    text: t("profile.support-code-copied"),
                    icon: "success",
                    confirmButtonText: t("global.ok"),
                });
                return;
            }

            if (!result.isDenied) return;

            const confirmation = await Swal.fire({
                title: t("profile.rotate-support-code"),
                text: t("profile.rotate-support-code-desc"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("profile.rotate"),
                cancelButtonText: t("global.cancel"),
            });

            if (!confirmation.isConfirmed) continue;

            action = "rotate";
            Swal.fire({
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => Swal.showLoading(),
            });
            code = await SupportCodeService.rotate();
            await Swal.fire({
                title: t("global.success"),
                text: t("profile.support-code-rotated"),
                icon: "success",
                confirmButtonText: t("global.ok"),
            });
        }
    } catch (error) {
        await Swal.fire({
            title: t("global.error"),
            text: t(action === "copy" ? "profile.support-code-copy-failed" : "profile.support-code-unavailable"),
            icon: "error",
            confirmButtonText: t("global.ok"),
        });
    } finally {
        dialogOpen = false;
    }
};

export default showSupportCodeDialog;
